import siteIcon from './siteIcon.png';
import CLLogo from './CL.png';
import nioLogo from './nioLogo.svg'
import closeBtnIcon from "./closecircle.svg";
import menuIcon from './hamMenuIcon.svg';

import fbIcon from './fbIcon.svg'
import googleIcon from './googleIcon.svg'
import crownIcon from './crown.svg';
import logoLoader from './logo-loader.gif';
import simpleTickIcon from "./simpleTickIcon.svg";
import expandIcon from "./expandIcon.svg";
import collapseIcon from "./collapseIcon.svg"
import inputErrorIcon from "./inputErrorIcon.svg"

const check = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/check.svg";
const checkbox = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/checkbox.svg";
const checkBoxPink = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/checkBoxPink.svg";
const checkFillPink = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/checkFillPink.svg";
const checkboxFill = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/checkboxFill.svg";
const infoIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/infoIcon.svg"

const errIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/errIcon.svg";
const successIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/successIcon.svg";
const copysuccess = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/copysuccess.svg";

const swipeNextIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/swipeNextIcon.svg";
const seperatorShort = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/seperatorShort.svg";
const explanationBtnIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/questionExpandIcon.svg";
const pillIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/pillIcon.svg";
const pillIconFaded = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/pillIconFaded.svg";
const arrowUp = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/arrowUp.svg";
const arrowDown = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/arrowdown2.svg";
const arrowDownIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/arrowDownIcon.svg";
const arrowRight = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/arrowright.svg";
const backIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/backIcon.svg";
const book = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/book1.svg";
const bookWithHowTextIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/bookWithHowTextIcon.svg"

const copyIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/copyIcon.svg";
const clockIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/clock.svg";
const underScoreIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/explanationUnderscore.svg";
const questionMessageIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/messagequestion.svg";
const exclamationIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/exclamationIcon.svg";
const exclamationIconPink = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/PinkExclamationIcon.svg";
const exclamationASKIconPink = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/Ask.svg";
const exclamationIconWithReport = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/Group+96611292.png";
const questionExpandIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/questionExpandIcon.svg"

const tickIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/tickIcon.svg"
const phoneIconURL = 'https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/PhoneIcon.svg';
const usersIconURL = 'https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/UsersIcon.svg';

const searchIcon = 'https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/search.svg';
const searchIconFill = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/search-fill.svg"

const delayTimeIconBlue = 'https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/category-colored-box(Blue).svg'
const delayTimeIconGreen = 'https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/category-colored-box(Green).svg'
const delayTimeIconYellow = 'https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/category-colored-box(Yellow).svg'

const delayTimeIconSmallBlue = 'https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/category-colored-box(-sBlue).svg'
const delayTimeIconSmallGreen = 'https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/category-colored-box(-sGreen).svg'
const delayTimeIconSmallYellow = 'https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/category-colored-box(-sYellow).svg'

const bestBuy = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/bestBuy.svg";
const fiftyChapters = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/50Chapters.svg";
const commentIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/comment-icon.svg"
const thumbIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/thumb-icon.svg"
const shareIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/share-icon.svg"
const saveIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/save-icon.svg"

const smiley1 = 'https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/smiley1.svg'
const smiley2 = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/smiley2.svg"
const smiley3 = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/smiley3.svg"
const smiley4 = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/smiley4.svg"

const starIcon = 'https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/star.svg'
const starFillIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/starFill.svg"

const whatsappIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/whatsappIcon.svg"
const linkedInIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/LinkedInIcon.svg"
const facebookIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/facebookIcon.svg"
const instagramIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/instagramIcon.svg"

const oneStar = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/1Star.svg"
const twoStar = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/2Stars.svg"
const threeStar = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/3Stars.svg"
const zeroStar = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/zeroStar.svg"

const editIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/editIcon.svg";

const seperatorMobileFirst = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/seperatorMobileFirst.svg"
const seperatorMobileSecond = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/seperatorMobileSecond.svg"
const seperatorMobileFull = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/seperatorMobileFull.svg"

const triangleUpGreenIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/triangleUpGreenIcon.png"
const hamMenuIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/hamMenuIcon.svg"

const selectIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/selectIcon.svg"
const selectedIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/selectedIcon.svg"

const appStoreImage = 'https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/appStoreImage.png'
const laptopMobileImage = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/laptopmobileLandingPage.svg"
const manavKImage = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/manavK.svg"

const testimonialImage1 = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/testimonialImage1.svg"
const testimonialImage2 = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/testimonialImage2.svg"
const testimonialImage3 = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/testimonialImage3.svg"

const trophyIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/trophyIcon.svg"
const locationIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/location.svg"
const messageTextIcon = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/messagetext.svg"
const googlePlayLinkImg = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/googlePlayLink.png"
const appStoreLinkImg = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/appStoreLinkImg.png"

const evaluationSelf3 = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/Advanced.png"
const evaluationSelf4 = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/Expert.png"


const Testinomial1 = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/1.png"
const Testinomial2 = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/2.png"
const Testinomial3 = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/3.png"
const Testinomial4 = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/5.png"
const Testinomial11 = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/6.png"
const Testinomial12 = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/9.png"
const Testinomial13 = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/15.png"
const Testinomial14 = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/16.png"

const SpedeVarLanding = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/undraw_time_management_re_tk5w+1.png"
const SpedeVarLandingCenter = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/undraw_exams_re_4ios+1.png"
const SpedeVarLandingRight = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/undraw_memory_storage_reh0+1.png"

const FounderPhotuManavDetails = "https://niopracticevideos.s3.ap-northeast-1.amazonaws.com/About_the_Founder+(1).png"

export {
    nioLogo,
    book,
    bookWithHowTextIcon,
    check,
    fbIcon,
    smiley1,
    smiley2,
    smiley3,
    smiley4,
    copyIcon,
    editIcon,
    googleIcon,
    selectIcon,
    hamMenuIcon,
    selectedIcon,
    arrowUp,
    arrowDown,
    arrowDownIcon,
    arrowRight,

    bestBuy,
    crownIcon,
    fiftyChapters,

    oneStar, twoStar, threeStar, zeroStar,
    logoLoader,
    errIcon,
    backIcon,
    pillIcon,
    tickIcon,
    siteIcon,
    CLLogo,
    menuIcon,
    checkbox,
    infoIcon,
    saveIcon,
    starIcon,
    thumbIcon,
    shareIcon,
    searchIcon,
    clockIcon,
    copysuccess,
    successIcon,
    commentIcon,
    closeBtnIcon,
    starFillIcon,

    whatsappIcon,
    linkedInIcon,

    facebookIcon,
    instagramIcon,
    phoneIconURL,
    usersIconURL,
    checkboxFill,
    checkBoxPink,
    swipeNextIcon,
    pillIconFaded,
    checkFillPink,
    seperatorShort,
    searchIconFill,
    underScoreIcon,
    exclamationIcon,
    exclamationIconPink,
    exclamationASKIconPink,
    exclamationIconWithReport,
    delayTimeIconBlue,
    delayTimeIconGreen,
    questionExpandIcon,
    explanationBtnIcon,
    questionMessageIcon,
    delayTimeIconYellow,
    delayTimeIconSmallBlue,
    delayTimeIconSmallGreen,
    delayTimeIconSmallYellow,
    seperatorMobileFirst,
    seperatorMobileFull,
    seperatorMobileSecond,
    triangleUpGreenIcon,

    laptopMobileImage,
    appStoreImage,
    manavKImage,
    testimonialImage1,
    testimonialImage2,
    testimonialImage3,
    trophyIcon,
    locationIcon,
    messageTextIcon,
    simpleTickIcon,
    expandIcon,
    collapseIcon,
    inputErrorIcon,
    googlePlayLinkImg,
    appStoreLinkImg,


    evaluationSelf3,
    evaluationSelf4,
    Testinomial1,
    Testinomial2,
    Testinomial3,
    Testinomial4,
    Testinomial11,
    Testinomial12,
    Testinomial13,
    Testinomial14,


    SpedeVarLanding,
    SpedeVarLandingCenter,
    SpedeVarLandingRight,
    FounderPhotuManavDetails
}